module.exports = __webpack_public_path__ + "img/LocationActive.f2574e4a.svg";